// extracted by mini-css-extract-plugin
module.exports = {"truncatedUserReview":"userReview-module__truncatedUserReview--3Ldo_"};